import React from 'react';

export const employmentDescription = (
  <div>
    <h3 className="vads-u-font-size--h4">Employment history</h3>
    <p>
      Now we’re going to ask you about your employment history. Please enter
      your most recent employer first and work back through the past 5 years. Be
      sure to include any time you were on military duty and inactive duty for
      training.
    </p>
    <p>
      For any time you were self-employed, enter your own name as the employer.
    </p>
  </div>
);
